module.exports = __webpack_public_path__ + "static/hummelgau-logo-87f1bad74cabaf432af7bd3e9fafe674.png";